import { gql, useQuery } from "@apollo/client"
import { isOS } from "@utils/useDeviceUtils"
import { PRINTER_FIELDS } from "./fragments/printerFieldsFragment"
import { DEVICE_PLATFORM_OS } from "../enums"

export const GET_PRINTERS_QUERY = gql`
  query PrintersByLocation($filter: PrinterFilterInput) {
    printers(filter: $filter) {
      list {
        ...PrinterFields
      }
    }
  }
  ${PRINTER_FIELDS}
`

const useQueryPrinters = (variables, options = {}) => {
  const queryOptions = {
    variables,
    ...options
  }

  return useQuery(GET_PRINTERS_QUERY, queryOptions)
}

const printersTypePolicies = {
  root: {},
  scoped: {
    USBPrinter: {
      fields: {
        deviceName: {
          read(_, { readField }) {
            return readField("address")
          }
        }
      }
    },
    BluetoothPrinter: {
      fields: {
        address: {
          read(_, { readField }) {
            if (isOS(DEVICE_PLATFORM_OS.IOS)) {
              return readField("iosAddress")
            }
            if (isOS(DEVICE_PLATFORM_OS.ANDROID)) {
              return readField("androidAddress")
            }
            return null
          }
        }
      }
    },
    BluetoothLowEnergyPrinter: {
      fields: {
        address: {
          read(_, { readField }) {
            if (isOS(DEVICE_PLATFORM_OS.IOS)) {
              return readField("iosAddress")
            }
            if (isOS(DEVICE_PLATFORM_OS.ANDROID)) {
              return readField("androidAddress")
            }
            return null
          }
        }
      }
    }
  }
}

export { useQueryPrinters, printersTypePolicies }
